module.exports = __webpack_public_path__ + "fonts/b03c5cd2-c6ad-4764-9cab-bf6211f181a7.62d0739c.woff";